"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formatID = _interopRequireDefault(require("../../../utils/formatID"));
var _lodash = require("lodash");
var _TertiaryMenu = require("./TertiaryMenu");
var _rightCaretMediumGray = _interopRequireDefault(require("../../../images/right-caret-medium-gray.svg"));
var _rightCaretLightGray = _interopRequireDefault(require("../../../images/right-caret-light-gray.svg"));
var _NavBar = require("../../NavBar/NavBar");
var _LunaLink = _interopRequireDefault(require("../../LunaLink/LunaLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const SubMenu = props => {
  const {
    menuProps,
    isOpen,
    links
  } = props;
  const {
    Link,
    deployedSubsection,
    deployedTertiary,
    mouseOverSubsection,
    mouseOverTertiary,
    mouseOverWithKeysMegaMenu,
    hasFeatures,
    mouseLeave,
    subNavHeightStyles,
    setMaxActiveNavItems,
    fullSubMenuParents,
    megaMenuParentValue
  } = menuProps;
  const {
    mouse,
    closeAllDropDowns
  } = (0, _react.useContext)(_NavBar.NavBarContext);
  const [isMousedOver, setIsMousedOver] = (0, _react.useState)(null);
  const [childOpen, setChildOpen] = (0, _react.useState)(null);
  const subMouseLeave = () => {
    setChildOpen(null);
  };
  const mouseOverFeature = feature => {
    setChildOpen(feature);
  };
  const navigateWithKeys = (e, id) => {
    mouseOverWithKeysMegaMenu(e, deployedSubsection, id);

    //check for enter key
    if (e.keyCode === 13) {
      mouseOverTertiary(id);
      mouseOverFeature(id);
    }
  };
  const updateMaxActiveNavItems = (currentLinks, megaMenuCount, fullSubMenuParents, e) => {
    e.stopPropagation();
    let highest = currentLinks > megaMenuCount && currentLinks > fullSubMenuParents ? currentLinks : megaMenuCount > currentLinks && megaMenuCount > fullSubMenuParents ? megaMenuCount : fullSubMenuParents > megaMenuCount && fullSubMenuParents > currentLinks ? fullSubMenuParents : null;
    if (highest != null) setMaxActiveNavItems(highest);
  };
  const generateTertiaryMenu = category => {
    const tertiaryIsOpen = deployedTertiary === category?.contentfulId;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: category?.contentfulId
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `ter-right-section__clip ${isOpen ? "ter-right-section__clip--is-open" : ""}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      tabIndex: mouse ? "" : "0",
      onMouseOver: () => {
        setIsMousedOver(category?.contentfulId);
      },
      onMouseLeave: () => {
        setIsMousedOver(null);
      },
      "data-depth": 3,
      onClick: e => {
        mouseOverSubsection(deployedSubsection);
        mouseOverTertiary(category?.contentfulId);
        updateMaxActiveNavItems(category?.links?.length, megaMenuParentValue, fullSubMenuParents, e);
      },
      onKeyDown: e => navigateWithKeys(e, category?.contentfulId),
      "aria-haspopup": "menu",
      "aria-expanded": tertiaryIsOpen,
      "aria-label": `${category?.text} sub menu`
      // id={formatID(`${category?.text}-mega-menu-left-title-text`)}
      ,
      className: `ter-mega-menu__left-title ${tertiaryIsOpen ? "ter-mega-menu__left-title--is-open-tertiary" : ""} ${mouse ? "" : "tabFocus"}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `ter-mega-menu__left-title--caret-wrapper`
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: `ter-mega-menu__left-title--text ${tertiaryIsOpen && !isMousedOver ? "ter-mega-menu__left-title--text--is-open" : ""}`
    }, category?.text), /*#__PURE__*/_react.default.createElement("img", {
      src: isMousedOver === category?.contentfulId ? _rightCaretLightGray.default : _rightCaretMediumGray.default,
      alt: "right caret",
      "aria-label": tertiaryIsOpen ? "Expanded" : "Collapsed",
      className: "ter-mega-menu__left-title-caret"
    })))), /*#__PURE__*/_react.default.createElement(_TertiaryMenu.TertiaryMenu, {
      Link: Link,
      links: category?.links,
      isOpen: tertiaryIsOpen,
      hasFeatures: hasFeatures,
      mouseLeave: mouseLeave,
      subNavHeightStyles: subNavHeightStyles
    }));
  };
  const generateLinks = () => {
    return links?.map((link, index) => {
      if (link?.links) {
        return generateTertiaryMenu(link);
      } else {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: link?.text + " " + index,
          onMouseOver: () => {
            mouseOverFeature(link?.contentfulId);
          },
          onMouseLeave: () => subMouseLeave(),
          className: `ter-right-section__clip ${isOpen ? "ter-right-section__clip--is-open" : ""}`
        }, /*#__PURE__*/_react.default.createElement(_LunaLink.default, {
          depth: 3,
          Link: Link,
          tabIndex: mouse ? "" : "0"
          // id={formatID(`${link?.text}-right-section-link`)}
          ,
          to: link?.url,
          href: link?.href,
          className: `ter-right-section__link ${childOpen === link?.contentfulId ? "ter-right-section__link--is-open" : ""} ${mouse ? "" : "tabFocus"}
              `,
          onClick: closeAllDropDowns,
          target: typeof link?.external === 'boolean' ? link?.external ? "_blank" : "_self" : null
        }, /*#__PURE__*/_react.default.createElement("p", {
          // id={formatID(`${link?.text}-mega-menu-item-link-text`)}
          className: `ter-right-section__link--underline ${childOpen === link?.contentfulId ? "ter-right-section__link--underline--is-open" : ""}`
        }, link?.text)));
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement("section", {
    className: `ter-right-section ${isOpen ? "ter-right-section--is-open" : ""} ${hasFeatures ? "ter-right-section--is-open--has-features" : ""}`,
    style: {
      ...subNavHeightStyles
    }
  }, generateLinks());
};
var _default = SubMenu;
exports.default = _default;